(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-collection"]) return;
  try {
    
  document.querySelectorAll('[data-mr-collection]').forEach((root) => {
    const chips = [...root.querySelectorAll('[data-mr-filter]')];
    const grid = root.querySelector('[data-mr-grid]');
    const cards = [...grid.querySelectorAll('.mr-card')];
    const count = root.querySelector('[data-mr-count]');
    const sort = root.querySelector('[data-mr-sort]');
    const kit = grid.querySelector('[data-mr-kit]');
    let active = new Set();

    const collator = new Intl.Collator('sv');
    const apply = () => {
      let visible = 0;
      cards.forEach((card) => {
        const show = active.size === 0 || active.has(card.dataset.handle);
        card.hidden = !show;
        if (show) visible += 1;
      });
      chips.forEach((chip) => {
        const key = chip.dataset.mrFilter;
        chip.setAttribute('aria-pressed', key === 'all' ? String(active.size === 0) : String(active.has(key)));
      });
      if (count) {
        count.textContent = active.size === 0 ? count.dataset.all : count.dataset.some.replace('{n}', visible).replace('{total}', cards.length);
      }
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const key = chip.dataset.mrFilter;
        if (key === 'all') active = new Set();
        else if (active.has(key)) active.delete(key);
        else active.add(key);
        apply();
      });
    });

    if (sort) {
      const original = cards.slice();
      sort.addEventListener('change', () => {
        let ordered = original.slice();
        const v = sort.value;
        if (v === 'name') ordered.sort((a, b) => collator.compare(a.dataset.title, b.dataset.title));
        if (v === 'price-asc') ordered.sort((a, b) => a.dataset.price - b.dataset.price);
        if (v === 'price-desc') ordered.sort((a, b) => b.dataset.price - a.dataset.price);
        ordered.forEach((card) => grid.insertBefore(card, kit || null));
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-fragrance-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mr-guide]').forEach((root) => {
    const dataEl = root.querySelector('[data-mr-guide-data]');
    if (!dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    // Trailing commas from skipped blocks are tolerated by cleaning the arrays.
    const questions = (data.questions || []).filter((q) => q && q.key);
    const scents = (data.scents || []).filter((s) => s && s.handle);
    if (!questions.length || !scents.length) return;

    const dots = [...root.querySelectorAll('[data-mr-dot]')];
    const stepLabel = root.querySelector('[data-mr-step-label]');
    const qEl = root.querySelector('[data-mr-question]');
    const bodyEl = root.querySelector('[data-mr-question-body]');
    const optionsEl = root.querySelector('[data-mr-options]');
    const resultEl = root.querySelector('[data-mr-result]');
    const altWrap = root.querySelector('[data-mr-alternatives]');
    const backBtn = root.querySelector('[data-mr-back]');
    const resetBtn = root.querySelector('[data-mr-reset]');

    let step = 0;
    const answers = {};

    const rank = () => scents
      .map((s, i) => {
        const score = questions.reduce((n, q) => n + (String(s.profile[q.key]) === String(answers[q.key]) ? Number(q.weight || 1) : 0), 0);
        return { s, score, i };
      })
      .sort((a, b) => b.score - a.score || a.i - b.i);

    const render = () => {
      const answered = questions.filter((q) => answers[q.key] !== undefined).length;
      const done = answered === questions.length;
      const q = questions[Math.min(step, questions.length - 1)];

      dots.forEach((d, i) => {
        d.classList.toggle('mr-guide__dot--done', done || answers[questions[i].key] !== undefined);
        d.classList.toggle('mr-guide__dot--current', !done && i === step && answers[questions[i].key] === undefined);
      });
      stepLabel.textContent = done ? data.labels.done : q.eyebrow;
      qEl.textContent = done ? data.labels.doneHeading : q.question;
      bodyEl.textContent = done ? data.labels.doneBody : q.body;
      backBtn.hidden = done || step === 0;
      resetBtn.hidden = answered === 0;

      optionsEl.innerHTML = '';
      optionsEl.hidden = done;
      if (!done) {
        q.options.forEach((o, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mr-guide__option';
          b.innerHTML =
            (o.swatch ? `<span class="mr-guide__swatch" style="--mr-fill:${o.swatch}"></span>` : '') +
            `<span class="mr-guide__index">0${i + 1}</span><span class="mr-guide__label"></span><span class="mr-guide__hint"></span>`;
          b.querySelector('.mr-guide__label').textContent = o.label;
          b.querySelector('.mr-guide__hint').textContent = o.hint || '';
          b.addEventListener('click', () => {
            answers[q.key] = o.value;
            step = Math.min(step + 1, questions.length - 1);
            render();
          });
          optionsEl.appendChild(b);
        });
      }

      resultEl.hidden = !done;
      altWrap.hidden = !done;
      if (done) {
        const ranked = rank();
        resultEl.querySelectorAll('[data-mr-scent]').forEach((c) => { c.hidden = c.dataset.mrScent !== ranked[0].s.handle; });
        const alts = ranked.slice(1, 3).map((r) => r.s.handle);
        altWrap.querySelectorAll('[data-mr-alt]').forEach((c) => { c.hidden = !alts.includes(c.dataset.mrAlt); });
        root.querySelector('.mr-guide').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    backBtn.addEventListener('click', () => {
      step = Math.max(0, step - 1);
      delete answers[questions[step].key];
      render();
    });
    resetBtn.addEventListener('click', () => {
      step = 0;
      Object.keys(answers).forEach((k) => delete answers[k]);
      render();
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-stockists"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mr-stockists]').forEach((root) => {
    const chips = [...root.querySelectorAll('[data-mr-country]')];
    const groups = [...root.querySelectorAll('[data-mr-group]')];
    const count = root.querySelector('[data-mr-store-count]');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const key = chip.dataset.mrCountry;
        let n = 0;
        groups.forEach((g) => {
          const show = key === 'all' || g.dataset.mrGroup === key;
          g.hidden = !show;
          if (show) n += Number(g.dataset.count || 0);
        });
        chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        if (count) count.textContent = `${n} ${n === 1 ? count.dataset.one : count.dataset.many}`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
